export default "__VITE_ASSET__D8$M0ixk__"